import { ScreeningAvailabilityStatus } from "../../../enum/screening-availability-status.enum";
import { ScreeningAvailabilityStrategyInterface } from "./screening-availability.strategy.interface";

/**
 * Determines if screening is available for sale
 */
export class ScreeningSaleAvailabilityStrategy implements ScreeningAvailabilityStrategyInterface {
  public isAvailable(availabilityStatus: number): boolean {
    availabilityStatus = Number.parseInt(availabilityStatus as any);

    return availabilityStatus === ScreeningAvailabilityStatus.ForSale ||
      availabilityStatus === ScreeningAvailabilityStatus.ForSaleAndReservation ||
      availabilityStatus === ScreeningAvailabilityStatus.ForPreview;
  }
}
